import {
    createSlice,
    createAsyncThunk
} from '@reduxjs/toolkit'
import axios from 'axios'
import { base_url } from '../../utils/config'

export const get_dashboard_index_data = createAsyncThunk(
    'dashboard/get_dashboard_index_data',
    async (userId, {
        rejectWithValue,
        fulfillWithValue, getState
    }) => {

        const { token } = getState().auth
        const config = {
            headers : {
                Authorization : `Bearer ${token}`
            }
        }

        try {
            const { data } = await axios.get(`${base_url}/api/home/customer/gat-dashboard-data/${userId}`, config);
            return data;
        } catch (error) {
            // This will pass the error to the rejected action
            return rejectWithValue(error.response.data);
        }
    }
)

export const dashboardReducer = createSlice({
    name: 'dashboard',
    initialState: {
        recentOrders: [],
        errorMessage: '',
        successMessage: '',
        totalOrder: 0,
        pendingOrder: 0,
        cancelledOrder: 0
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ''
            state.successMessage = ''
        }
    },
    extraReducers: {
        [get_dashboard_index_data.fulfilled]: (state, { payload }) => {
            if (payload) {
                state.totalOrder = payload.totalOrder || 0; // Provide default values
                state.pendingOrder = payload.pendingOrder || 0;
                state.cancelledOrder = payload.cancelledOrder || 0;
                state.recentOrders = payload.recentOrders || [];
            }
        },
        [get_dashboard_index_data.rejected]: (state, { payload }) => {
            // Update the state with error message
            state.errorMessage = payload || 'Failed to fetch data';
        }
    }
    
})

export const {
    messageClear
} = dashboardReducer.actions
export default dashboardReducer.reducer